
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48.904","height":"48.904"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Groupe 420"}},[_c('path',{attrs:{"data-name":"Tracé 6743","d":"M24.452 0a24.452 24.452 0 1024.452 24.452A24.477 24.477 0 0024.452 0zm9.719 14.638a3.265 3.265 0 012.37 5.6l-13.046 13.04a3.259 3.259 0 01-4.609 0l-4.892-4.892a3.261 3.261 0 114.61-4.609l2.587 2.587 10.733-10.739a3.33 3.33 0 012.247-.987z","fill":"#43ad9e"}})])])
          )
        }
      }
    